import React, { useEffect } from 'react';
import Modal from './Modal';
import Icon from '../AppIcon';
import Button from './Button';

const SuccessModal = ({
  isOpen,
  onClose,
  title = "Success!",
  message,
  autoClose = true,
  autoCloseDelay = 3000,
  onRedirect,
  redirectUrl
}) => {
  useEffect(() => {
    if (isOpen && autoClose) {
      const timer = setTimeout(() => {
        onClose();
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose, redirectUrl]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      showCloseButton={!autoClose}
    >
      <div className="text-center py-8">
        {/* Success Icon */}
        <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
          <Icon name="CheckCircle" size={32} className="text-green-600" />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-foreground mb-2">
          {title}
        </h3>

        {/* Message */}
        <p className="text-muted-foreground mb-6">
          {message}
        </p>

        {/* Manual Close Button (if not auto-closing) */}
        {!autoClose && (
          <Button onClick={onClose} className="w-full">
            Continue
          </Button>
        )}

        {/* Auto-close indicator */}
        {autoClose && (
          <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
            <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
            <span>Redirecting...</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SuccessModal;
